import React, {useEffect, useId, useState} from 'react';
import FormField from '../FormField/FormField';
import SubmitButton from '../SubmitButton/SubmitButton';
import './CreateEmployee.css';
import {fetchWorkplaces} from '../../api/workplaceApi';
import {addUserToWorkplace} from '../../api/staffApi';
import NotificationPopup from '../NotificationPopup/NotificationPopup';
import {createPortal} from 'react-dom';
import {useMemo} from 'react';
const requiredFields = ['login', 'workplace_ids'];
const modifierClassesFormField = {
  field: 'create-employee__textarea',
};

const CreateEmployee = ({
  handleClose,
  isEmployeeFormOpen,
  selectedItemId,
  updateTabData,
  selectedTab,
}) => {
  const [workplacesList, setWorkplacesList] = useState([]);

  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [loginInvitedUser, setLoginInvitedUser] = useState('');
  const generatedId = useId();
  const [formData, setFormData] = useState({
    login: '',
    comment: '',
    workplace_ids: [],
    errors: {},
  });

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const [workplacesData] = await Promise.all([
          fetchWorkplaces(selectedItemId),
        ]);
        setWorkplacesList(
          workplacesData.data?.map((el) => ({
            value: el.id,
            label: el.name,
          })) || []
        );
      } catch (error) {
        console.error('Ошибка загрузки ролей:', error);
      }
    };
    if (selectedItemId) loadRoles();
  }, [selectedItemId]);

  const fieldLabels = useMemo(
    () => [
      {key: 'login', label: 'Логин', type: 'text'},
      {
        key: 'workplace_ids',
        label: 'Рабочие места',
        type: 'select',
        placeholder: 'Выберите рабочие места',
        options: workplacesList,
        isMulti: true,
      },
      {key: 'comment', label: 'Комментарий', type: 'textarea'},
    ],
    [workplacesList]
  );

  const validateField = (name, value, prevForm = {errors: {}}) => {
    if (requiredFields.includes(name) && !value?.toString().trim()) {
      return 'Поле обязательно';
    }

    if (
      name === 'workplace_ids' &&
      Array.isArray(prevForm.errors.selectTagErr) &&
      prevForm.errors.selectTagErr.length > 0
    ) {
      const nextSelectTagErr = prevForm.errors.selectTagErr.filter((tag) =>
        value.includes(tag)
      );

      const nextErrors = {...prevForm.errors, selectTagErr: nextSelectTagErr};

      if (nextSelectTagErr.length === 0) {
        delete nextErrors.selectTagErr;
        if (nextErrors.login === 'Этот пользователь уже приглашен') {
          delete nextErrors.login;
        }
      }

      return nextErrors; // возвращаем обновлённый объект ошибок
    }

    return null;
  };

  const handleChange = (e) => {
    const {name, value} = e.target;

    setFormData((prev) => {
      const updatedErrors = validateField(name, value, prev);

      return {
        ...prev,
        [name]: value,
        errors:
          updatedErrors !== null
            ? updatedErrors
            : {
                ...prev.errors,
                [name]:
                  requiredFields.includes(name) && !value?.toString().trim()
                    ? 'Поле обязательно'
                    : undefined,
              },
      };
    });
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    requiredFields.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) {
        errors[field] = error;
        isValid = false;
      }
    });

    setFormData((prev) => ({...prev, errors}));
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const dataToSend = {
        login: formData.login,
        comment: formData.comment,
        workplace_ids: formData.workplace_ids,
        organisation_id: selectedItemId,
      };

      await addUserToWorkplace(dataToSend);

      // Сброс формы и закрытие
      setFormData({
        login: '',
        comment: '',
        workplace_ids: [],
        role_ids: [],
        errors: {},
      });
      await updateTabData(selectedTab);
      setIsNotificationVisible(true);
      setLoginInvitedUser(formData.login);
      handleClose();
    } catch (error) {
      console.error('Ошибка при добавлении сотрудника:', updateTabData());

      const rawMessage = error?.data?.message || '';
      const [messageText, jsonPart] = rawMessage.split('&');

      let ids = [];
      try {
        if (jsonPart) ids = JSON.parse(jsonPart);
      } catch {
        ids = [];
      }

      if (messageText === 'Organisation id is not valid or user not found') {
        setFormData((prev) => ({
          ...prev,
          errors: {login: 'Пользователь с таким логином не найден'},
        }));
      } else if (messageText === 'The employee has already been invited.') {
        setFormData((prev) => ({
          ...prev,
          errors: {
            login: 'Этот пользователь уже приглашен',
            selectTagErr: ids,
          },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          errors: {commonErr: 'Ошибка приглашения сотрудника'},
        }));
      }
    }
  };

  useEffect(() => {
    if (isNotificationVisible) {
      const timer = setTimeout(() => {
        setIsNotificationVisible(false);
        setLoginInvitedUser('');
      }, 6000);

      return () => clearTimeout(timer); // Очищаем таймер при размонтировании
    }
  }, [isNotificationVisible]);
  return (
    <>
      <div
        className={`overlay ${isEmployeeFormOpen ? 'show' : 'hide'}`}
        onClick={handleClose}
      />

      <section
        className={`create-employee ${isEmployeeFormOpen ? 'show' : 'hide'}`}
      >
        <div className='create-employee__form'>
          <div className='create-employee__header'>
            <h2 className='create-employee__header-title'>
              Добавить сотрудника
            </h2>
            <SubmitButton
              className='create-employee__save-button'
              text='Пригласить сотрудника'
              type='submit'
              onClick={handleSubmit}
            />
            <button onClick={handleClose} className='profile__close-btn' />
            {formData.errors.commonErr && (
              <span className='commonErr'>{formData.errors.commonErr}</span>
            )}
          </div>

          <form className='create-employee__form-container'>
            {fieldLabels.map(
              ({key, label, type, options, placeholder, isMulti}) => (
                <FormField
                  key={`${key}-${generatedId}`}
                  label={label}
                  name={key}
                  value={formData[key] || ''}
                  onChange={handleChange}
                  error={formData.errors[key]}
                  selectTagErr={formData?.errors?.selectTagErr || []}
                  required={requiredFields.includes(key)}
                  type={type}
                  options={options}
                  placeholder={placeholder}
                  modifierClassesFormField={modifierClassesFormField}
                  isMulti={isMulti}
                />
              )
            )}
          </form>
        </div>
      </section>
      {isNotificationVisible &&
        createPortal(
          <NotificationPopup
            duration={5000}
            message={`Приглашение отправлено пользователю с логином ${loginInvitedUser}`}
            onClose={() => console.log('закрыть')}
          />,
          document.body
        )}
    </>
  );
};

export default CreateEmployee;
